<script lang="ts">
    import { onMount } from 'svelte'
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import DateSelect from '../_common/date-select.svelte'
    import Zgrid from '../_common/z/zgrid.svelte'
    import { GridBadge, GridBadgeClassEnum, GridClass, GridCol, GridButton, GridColTypeEnum, GridLine } from '../_common/z/zgrid'
    import type { TaggedPersonDto } from '../../modules/eventsApi/tags/tagged-person.dto'
    import { faUser } from '@fortawesome/free-solid-svg-icons'
    import Zframe from '../_common/z/zframe.svelte'
    import Zflow from '../_common/z/zflow.svelte'
    import { ChartData } from '../_common/z/zchart'
    import Zchart from '../_common/z/zchart.svelte'
    import type { TagEntity } from '../../modules/eventsApi/tags/tag.entity'
    import Zact from '../_common/z/zact.svelte'
    // ##############################################################################################################

    let dates: { from: Date; to: Date } = window.api.utils.dates.currentMonth()
    let tags: { value: string; label: string; add: boolean; remove: boolean; chart: boolean }[] = []
    let entities: { personId: string; name: string; tags: { label: string; tagId: string }[] }[] = []
    let allTags: TagEntity[] = []
    let selectedTag = ''
    let daysRange: string = '30/30'

    let andOr: 'or' | 'and' = 'or'

    let firstLastEvent: 'first' | 'last' = 'first'

    async function loadAllTags() {
        allTags = await window.api.events.tags.getAll()
    }

    async function loadEntities() {
        try {
            show = true
            let result: TaggedPersonDto[] = []
            let rangeFrom = undefined
            let rangeTo = undefined
            if (selectedTag) {
                rangeFrom = parseInt(daysRange.split('/')[0])
                rangeTo = parseInt(daysRange.split('/')[1])
            }
            result = await window.api.events.tags.getTaggedPersons(dates.from, dates.to, firstLastEvent === 'last', selectedTag, rangeFrom, rangeTo)
            console.log('tagged', result)
            entities = []
            for (const item of result) {
                let found = entities.find((el) => el.personId === item.personId)
                if (!found) {
                    found = {
                        name: item.person.name,
                        personId: item.personId,
                        tags: [],
                    }
                    entities.push(found)
                }
                found.tags.push({
                    label: item.tag.label,
                    tagId: item.tagId,
                })
            }
            extractTags()
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function dateChanged(event) {
        dates = event.detail
        loadEntities()
    }

    let show = false

    onMount(async () => {
        await loadAllTags()
        await loadEntities()
    })

    function extractTags() {
        tags = []
        for (const person of entities) {
            for (const tag of person.tags) {
                if (tags.some((el) => el.value === tag.tagId)) continue
                tags.push({
                    value: tag.tagId,
                    label: tag.label,
                    add: true,
                    remove: false,
                    chart: true,
                })
            }
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        let chartContent: { label: string; total: number }[] = []
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Pessoas'
        grid.fontSize = '14px'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Pessoa', class: 'fix-w_250', maxLength: 33 }))
        grid.cols.push(new GridCol({ content: 'Etiqueta', type: GridColTypeEnum.badge }))
        grid.cols.push(new GridCol({ type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            let line: GridLine = new GridLine()
            let btnPerson: GridButton = new GridButton({
                callback: () => window.person('show', item.personId),
                icon: faUser,
            })

            line.slots.push({ content: item.name })
            const badges: GridBadge[] = []

            if (item.tags.some((el) => tags.find((tg) => tg.value === el.tagId && tg.remove))) continue
            if (andOr === 'or') {
                if (!item.tags.some((el) => tags.find((tg) => tg.value === el.tagId && tg.add))) continue
            } else {
                let foundAllTags = true
                // se não possui todas as tags então não adiciona a pessoa
                tags.forEach((tag) => {
                    if (tag.add) {
                        if (!item.tags.some((el) => el.label === tag.label)) {
                            foundAllTags = false
                            console.log('not found', tag.label)
                            return
                        }
                    }
                })
                if (!foundAllTags) continue
                console.log('all was found')
            }
            for (const tag of tags) {
                const found = item.tags.some((el) => el.tagId === tag.value)
                badges.push({
                    label: tag.label,
                    class: found ? GridBadgeClassEnum.badge_blue : GridBadgeClassEnum.badge_disabled,
                    color: null,
                })

                if (tag.chart) {
                    let chartFound = chartContent.find((el) => el.label === tag.label)
                    if (!chartFound) {
                        chartFound = {
                            label: tag.label,
                            total: 0,
                        }
                        chartContent.push(chartFound)
                    }
                    if (found) chartFound.total += 1
                }
            }
            line.slots.push({ content: badges })
            line.slots.push({ content: [btnPerson] })
            grid.lines.push(line)
        }
        loadChart(chartContent)
    }

    function onFilterChange() {
        loadGrid()
    }

    let chart: ChartData
    function loadChart(chartContent: { label: string; total: number }[]) {
        chartContent.sort((a, b) => b.total - a.total)
        chart = new ChartData({
            categories: [...chartContent.map((el) => el.label)],
            type: 'bars',
            title: 'Gráfico',
            series: [{ data: [...chartContent.map((el) => el.total)] }],
        })
    }
</script>

<Content>
    <Zact>
        <DateSelect startFrom={dates.from} startTo={dates.to} on:change={dateChanged} />
        <div class="spacer" />
    </Zact>
    <Zflow>
        <Zframe title="Central de Etiquetas" class="mt-3">
            <div class="d-flex flex-wrap mb-2 gap-2">
                <div class="input-group fix-w_350">
                    <label for="" class="input-group-text">Buscar por</label>
                    <select class="form-select" bind:value={firstLastEvent} name="" id="" on:change={() => loadEntities()}>
                        <option value="first">data da primeira atribuição</option>
                        <option value="last">data da última atribuição</option>
                    </select>
                </div>
                <div class="input-group limit-w_800">
                    <label for="" class="input-group-text">Considerar data da etiqueta</label>
                    <select class="form-select" bind:value={selectedTag} name="" id="" on:change={() => loadEntities()}>
                        <option value="">[todas as etiquetas]</option>
                        {#each allTags as tag}
                            <option value={tag.tagId}>{tag.label}</option>
                        {/each}
                    </select>
                    {#if selectedTag}
                        <label for="" class="input-group-text">e demais até</label>
                        <select class="form-select" bind:value={daysRange} name="" id="" on:change={() => loadEntities()}>
                            <option value="365/0">365 dias atrás</option>
                            <option value="180/0">180 dias atrás</option>
                            <option value="90/0">90 dias atrás</option>
                            <option value="60/0">60 dias atrás</option>
                            <option value="30/0">30 dias atrás</option>
                            <option value="30/30">30 dias atrás ou à frente</option>
                            <option value="60/60">60 dias atrás ou à frente</option>
                            <option value="90/90">90 dias atrás ou à frente</option>
                            <option value="180/180">180 dias atrás ou à frente</option>
                            <option value="365/365">365 dias atrás ou à frente</option>
                            <option value="0/30">30 dias à frente</option>
                            <option value="0/60">60 dias à frente</option>
                            <option value="0/90">90 dias à frente</option>
                            <option value="0/180">180 dias à frente</option>
                            <option value="0/365">365 dias à frente</option>
                        </select>
                    {/if}
                </div>
            </div>

            <div class="d-flex mb-1">
                <div class="form-check form-check-inline pe-3">
                    <input type="radio" name="andOr" bind:group={andOr} value="or" id="andOr_or" class="form-check-input" on:change={onFilterChange} />
                    <label for="andOr_or">Incluir pessoas com ao menos uma destas etiquetas</label>
                </div>
                <div class="form-check form-check-inline me-2">
                    <input type="radio" name="andOr" bind:group={andOr} value="and" id="andOr_and" class="form-check-input" on:change={onFilterChange} />
                    <label for="andOr_and">Incluir pessoas com TODAS estas etiquetas</label>
                </div>
            </div>
            <div class="btn-group btn-group-sm" role="group">
                {#each tags as tag, index (tag.value)}
                    <input bind:checked={tag.add} type="checkbox" class="btn-check" id="btnadd_{index}" autocomplete="off" on:change={onFilterChange} />
                    <label class="btn btn-outline-primary" for="btnadd_{index}">{tag.label}</label>
                {/each}
            </div>
            <label class="mt-2 mb-1" for="">Remover pessoas com estas etiquetas</label>
            <div class="btn-group btn-group-sm" role="group">
                {#each tags as tag, index (tag.value)}
                    <input bind:checked={tag.remove} type="checkbox" class="btn-check" id="btnrem_{index}" autocomplete="off" on:change={onFilterChange} />
                    <label class="btn btn-outline-danger" for="btnrem_{index}">{tag.label}</label>
                {/each}
            </div>
            <label class="mt-2 mb-1" for="">Exibir estas etiquetas no gráfico</label>
            <div class="btn-group btn-group-sm" role="group">
                {#each tags as tag, index (tag.value)}
                    <input bind:checked={tag.chart} type="checkbox" class="btn-check" id="btnchart_{index}" autocomplete="off" on:change={onFilterChange} />
                    <label class="btn btn-outline-secondary" for="btnchart_{index}">{tag.label}</label>
                {/each}
            </div>
        </Zframe>
        <Zchart data={chart}></Zchart>
        <Zgrid {grid} />
    </Zflow>

    <LoadSpinner {show} />
</Content>
